// extracted by mini-css-extract-plugin
module.exports = {"labelEl":"CheckBox_labelEl__2P9tA","labelEl__text":"CheckBox_labelEl__text__2jjwU","inputEl":"CheckBox_inputEl__1rzRM"};